<template>
  <div>
    <!-- Overlay -->
    <div v-if="menuOpen" class="bg-black/60 fixed inset-0 z-40" @click="toggleMenu"></div>

    <!-- Sidebar -->
    <aside
      :class="`transform top-0 left-0 w-64 bg-[#0f173e] text-gray-200 fixed h-full shadow-lg border-r border-gray-700 transition-transform duration-300 ease-in-out z-50 ${
        menuOpen ? 'translate-x-0' : '-translate-x-full'
      }`"
      @click.stop
    >
      <div class="flex items-center justify-between px-4 py-4 border-b border-gray-700">
        <span class="text-lg font-bold tracking-wide text-white">Panel de Control</span>
        <button @click="toggleMenu" class="text-gray-400 hover:text-white text-xl">&times;</button>
      </div>

      <ul class="px-4 py-2 space-y-1 text-sm">
        <li>
          <router-link to="/lista-usuarios" class="nav-link-dark" @click="closeMenu">
            👥 Gestión de invitados
          </router-link>
        </li>
        <li v-if="canView('superadministrador')">
          <router-link to="/eventos" class="nav-link-dark" @click="closeMenu">
            📅 Gestión de eventos
          </router-link>
        </li>
        <li v-if="canView('superadministrador', 'administradorevento')">
          <router-link to="/buscador" class="nav-link-dark" @click="closeMenu">
            🔍 Buscador
          </router-link>
        </li>
        <li>
          <router-link
            :to="'/dashboard/user/edit/' + $store.state.user.token"
            class="nav-link-dark"
            @click="closeMenu"
          >
            ⚙️ Editar mi perfil
          </router-link>
        </li>
        <li>
          <a href="#" class="nav-link-dark" @click="logoutAndClose">
            🚪 Cerrar sesión
          </a>
        </li>
      </ul>
    </aside>

    <!-- Main Navbar -->
    <nav class="bg-[#0f173e] border-b border-gray-700 text-white fixed top-0 left-0 right-0 z-30 shadow-sm">
      <div class=" mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-14">
          <div class="flex items-center">
            <button
              @click="toggleMenu"
              class="text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-teal-400"
            >
              ☰
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<style scoped>
.nav-link-dark {
  display: block;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  color: #d1d5db; /* text-gray-300 */
  font-weight: 500;
  transition: background-color 0.2s ease;
}
.nav-link-dark:hover {
  background-color: #0f173e; /* hover:bg-gray-700 */
  color: #fff;
}

a {
  text-align: left;
}
nav {
  padding: 5px 30px;
}
</style>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      role: null,
      menuOpen: false,
      roleLoaded: false,
      
    };
  },
  computed: {      
    roleToken() {
      return this.$store.state.roleToken;
    },
  },
  mounted() {
    this.validateRole();    
  },
  methods: {
    ...mapActions(['logout']),
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      if (this.menuOpen) {
        this.menuOpen = false;
      }
    },
    logoutAndClose() {
      this.logout();
      this.closeMenu();
    },
    async validateRole() {
      // console.log("Role token:", this.roleToken);

      if (!this.roleToken) {
        this.roleLoaded = true;
        return;
      }
      try {
        const response = await axios.post('/api/verify-role', {
          roleToken: this.roleToken
        });
        // console.log('Role response:', response.data); // Agregar un log para depuración
        this.role = response.data.role;
      } catch (error) {
        // console.error('Error verifying role:', error);
        this.role = null;
      } finally {
        this.roleLoaded = true;
      }
    },
    canView(...expectedRoles) {
        if (!this.roleLoaded) {
            return false;
        }
        const roleHierarchy = {
            'usuario': 1,
            'administrador': 2,
            'administradorevento': 3,
            'superadministrador': 4
        };

        return expectedRoles.some(role => roleHierarchy[this.role] >= roleHierarchy[role]);
    }
  }
}
</script>
